import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    addRatingGroup : [],
    loading : false,
    error : null,
};

const addRatingGroupSlice = createSlice({
    name:"addRatingGroup",
    initialState,
    reducers: {
        fetchaddRatingGroupSuccess: (state,action) => {
            state.loading = false;
            state.addRatingGroup = action.payload;
        },
        fetchaddRatingGroupFailure: (state,action) => {
            state.loading = false;
            state.error = action.payload
        }
    },
})

export const {
    fetchaddRatingGroupSuccess,
    fetchaddRatingGroupFailure
} = addRatingGroupSlice.actions

export default addRatingGroupSlice.reducer